module.exports = __webpack_public_path__ + "static/media/mrpostman.5e811df3.jpg";